function required(value, name) {
  if (!value) {
    throw new Error(
      `Missing required env var ${name}. Copy .env.example to .env and fill it in.`,
    );
  }
  return value;
}

export const env = {
  apiBaseUrl: required(
    process.env.REACT_APP_GIDEX_API_BASE_URL,
    // "https://gidexstage.ginox.io",
    "REACT_APP_GIDEX_API_BASE_URL",
  ),
  adminApiKey: required(
    process.env.REACT_APP_OMNISERVE_KEY,
    "REACT_APP_OMNISERVE_KEY",
  ),
};
